import {atom} from 'jotai';
import {atomWithImmer} from 'jotai-immer';
import {store} from './global';
import {processTimerIntent} from "./timer";
import {processActiveIntent} from "./active";
//import {processRecipesIntent} from "./recipes";

// jotai audio state
export const vadAtom = atom(null);
export const audioAtom = atomWithImmer({
  vadState: 'off', // off, listening, recording
  volume: 0.8,
  rate: 1.2,
});
export const speechesAtom = atomWithImmer([]);
export const speechAudio = atom(null);

// generate speech from text
export const genSpeech = (payload: any) => {
  let text = "";
  let is_ssml = false;
  if (typeof payload === "string") {
    text = payload;
  } else {
    text = payload.text;
    is_ssml = payload.is_ssml;
  }
  const vad = store.get(vadAtom);
  const audio = store.get(audioAtom);
  const voices = speechSynthesis.getVoices().filter((voice) => voice.lang === "en-US");
  console.log("my gen speech", text, is_ssml, vad, audio);
  if (text) {
    store.set(speechesAtom, (state) => {
      state.push(text);
    });
    vad.pause();
    store.set(audioAtom, (state) => {
      state.vadState = "off";
    });
    const msg = new SpeechSynthesisUtterance(text);
    msg.rate = audio.rate;
    msg.volume = audio.volume;
    msg.onend = (event) => {
      console.log("speech ended", event);
      vad.start();
      store.set(audioAtom, (state) => {
        state.vadState = "listening";
      });
    };
    window.speechSynthesis.speak(msg);
  }
}

// stops current speech
export const stopSpeech = () => {
  window.speechSynthesis.cancel();
}

// processes a successfully matched intent
export const processIntent = (intent) => {
  console.log("Got cookery intent", intent);
  //const timers = Object.assign({}, state.timers);
  let name = null;
  const now = new Date();
  switch (intent.name) {
    case "stop":
      stopSpeech();
      break;
    case "repeat":
      stopSpeech();
      const speeches = store.get(speechesAtom);
      if (speeches.length > 0) {
        genSpeech(speeches.at(-1));
      }
      break;
    case "FallbackIntent": //TODO we do nothing for now
      // genSpeech({text: "Sorry, did not understand that"});
      break;
    default: // dispatch other intents
      if (intent.name.includes("_timer")) {
        processTimerIntent(intent);
      } else {
        processActiveIntent(intent);
      }
  }
}

// processes output from lex
export const processLex = (obj) => {
  console.log("Processing lex", obj);
  const intent = obj.interpretations[0].intent; // use .nluConfidence if wanted...
  if (intent.state === "ReadyForFulfillment") {
    processIntent(intent);
  }
};

